var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeDarkGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 12.4264C12.4695 12.4264 14.0665 10.8295 14.0665 8.85951C14.0665 6.88956 12.4695 5.2926 10.4996 5.2926C8.52964 5.2926 6.93268 6.88956 6.93268 8.85951C6.93268 10.8295 8.52964 12.4264 10.4996 12.4264Z",
    stroke: "#98A2B3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.925 7.15258C17.8106 4.40691 13.9907 1.57349 10.4996 1.57349C7.0085 1.57349 3.18943 4.40691 1.07501 7.15258",
    stroke: "#98A2B3",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeDarkGray);
export default __webpack_public_path__ + "static/media/eye-dark-gray.e69ed8dae6364a8a547d1313f9874489.svg";
export { ForwardRef as ReactComponent };